import { render, staticRenderFns } from "./ConfiguratorStep.vue?vue&type=template&id=5bf333c6"
import script from "./ConfiguratorStep.vue?vue&type=script&lang=js"
export * from "./ConfiguratorStep.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorStep.vue?vue&type=style&index=0&id=5bf333c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports